import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getSupplementDetails } from '@api/supplements';
import { IDietarySupplementDetails } from '@interfaces/supplements';

export const handleGetSupplementDetails = createAsyncThunk<
  AxiosResponse<IDietarySupplementDetails>,
  { id: number }
>('getSupplementDetails', ({ id }) => getSupplementDetails(id));
